
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index7Yauh9eR585NE3nBrnpMnBWlOuvO3S2MPsBjYzaMoFQMeta } from "/home/runner/work/web-frontend/web-frontend/pages/index.vue?macro=true";
import { default as searchDvj7gJOb8g5F20Jono15OaLEvCbPwirC_bg8gt80nqIMeta } from "/home/runner/work/web-frontend/web-frontend/pages/search.vue?macro=true";
import { default as articlekE6O7IfpLIgXnzVQWW9pe9WAgwNpEP75PMRtnCXrdOYMeta } from "/home/runner/work/web-frontend/web-frontend/pages/article.vue?macro=true";
import { default as _91_46_46_46uri_93UlVo4mjnr3dERL06YSB7lBX58g31XxfInItofUr_45bF8Meta } from "/home/runner/work/web-frontend/web-frontend/pages/[...uri].vue?macro=true";
import { default as formMceNzHXKbZ_VlnYoLRwBtsOqkH3gAJHtHRHF3Lpzs9wMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/form.vue?macro=true";
import { default as tabsE1Cs8gTo1WgudwQyrQOUsRUfIyGy1gH_45AFRefb1CEqkMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/tabs.vue?macro=true";
import { default as indexljpHVTxGAQtzdGp7pqAb7aQDFVZYFj1ixDGN_xEYN_45IMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/index.vue?macro=true";
import { default as linksfbO2qSTJwUZ5uUinThpg1XVV3iGiLHoapLQyDu2O0nwMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/links.vue?macro=true";
import { default as quote3LgRriJFl3kkfemBHgqB73l35ZzWDVyTLtZB0waiUZUMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/quote.vue?macro=true";
import { default as table6MBU_hUtWuOsrRTbS3pLf9N0JzRGFMqs0vdH6zWXkZsMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/table.vue?macro=true";
import { default as tilessU34h04Yc3SH3yK2lKZOyxxRcldWcUEV_oh4kW_vv8IMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/tiles.vue?macro=true";
import { default as videoO_CGQ_45eon53Y9yIqh12pQkiKJ_45LF3_kJ5qaxB_kX0UwMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/video.vue?macro=true";
import { default as imagesTGIA6GgBnsCgggCw_ONuZmKf_45c84mGXtCZW_Bq8TgTgMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/images.vue?macro=true";
import { default as layout_B1LEDHOKiemPPW4hplJEHtPKtH53nvoTnp8r_45_zUYYMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/layout.vue?macro=true";
import { default as dividerCZVyUEzD4slqIImtgpMjitylZGypO9mWFz6uzTH2AjcMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/divider.vue?macro=true";
import { default as galleryEDCLkHoeEoLglk95VJDL3dvmovvZU5EVNnZHpXSshscMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/gallery.vue?macro=true";
import { default as accordionphWzN5evVHr7WQBW5nSBcqivF_45jUeckkTgNWPmwYOsEMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/accordion.vue?macro=true";
import { default as rich_45text8ve5qDePm74PvuFmXsm2Agm22R_45IfALd5iLhj9KPhU0Meta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/rich-text.vue?macro=true";
import { default as button_45groupuZJ_459UWQgXb_45J1J3MkDmiC9d6VXkA9Pc98wBekbc9E0Meta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/button-group.vue?macro=true";
import { default as news_45listinge8nshuRJeiAhdLDlaAGcBdkTSMF20J9TMFdTAoZGyj4Meta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/news-listing.vue?macro=true";
import { default as feature_45tilessJLgcRj7rH0u4OWiDnVjxDPNcScwR5f_45rvB0wihgVXMMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/feature-tiles.vue?macro=true";
import { default as events_45listinghHESxqwb98zQmVYUzlPhhKWt4WbrJDkMnBpunex0LGMMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/events-listing.vue?macro=true";
import { default as events_45calendaruKNUm7y4XCsJrhBs1L9XrSFsuV11GYy4fShb3fzR_45mYMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/events-calendar.vue?macro=true";
import { default as staff_45directoryb8gY_451WxGlU8s6avHDbrxLN1XWWfSCS9St7OdjX_IYwMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/staff-directory.vue?macro=true";
import { default as social_45media_45feedfj_45pZpbS2qXFtQUUndG7Ta3fpmarLBKuEgXKtk18Y1MMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/social-media-feed.vue?macro=true";
import { default as athletics_45calendar_us7ptbshhTXuU1V9PAAr2FE65_cZI_45Jyd_9kZc1iMsMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/athletics-calendar.vue?macro=true";
import { default as image_45and_45links_45columns51DpMQcelX0fFBXL3SXPoVbZmQXUt_45EsWTcMirmg81kMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/image-and-links-columns.vue?macro=true";
import { default as image_45and_45text_45accordionRJuVHgcNp2nK8AucXNSVXcVwXvAbXX4qHn8dKpj7Q18Meta } from "/home/runner/work/web-frontend/web-frontend/pages/sections/image-and-text-accordion.vue?macro=true";
import { default as sectionspIfzhKb0mBRvKvAIZ7AEgghtQR3SM5N7oF7vRmDfRrsMeta } from "/home/runner/work/web-frontend/web-frontend/pages/sections.vue?macro=true";
import { default as index7v4lj34RvGS5sPkL_45J2DTTE98fwgtjqo3wDuoiuY4WoMeta } from "/home/runner/work/web-frontend/web-frontend/pages/block-tests/index.vue?macro=true";
import { default as _91block_93jttgHwedITlq5tltWn05G5DD9OJWbAKxsB4wMjyf_45G8Meta } from "/home/runner/work/web-frontend/web-frontend/pages/block-tests/[block].vue?macro=true";
import { default as configl2QSg5VG4P1I2oxXTjIr7U9acR1y_hR7eoaC8SODOGQMeta } from "/home/runner/work/web-frontend/web-frontend/pages/block-tests/blocks/ds_TabsBlock/config.js?macro=true";
import { default as configzxl4DOx5KD5x7mewe6wumqSj3KRY1zZCPzMEvz4AUpgMeta } from "/home/runner/work/web-frontend/web-frontend/pages/block-tests/blocks/ds_ImagesBlock/config.js?macro=true";
import { default as configSn7rRc0J52pkt84Qr_457_bm9JUvqrmx8c965Q9GTnCSAMeta } from "/home/runner/work/web-frontend/web-frontend/pages/block-tests/blocks/ds_GalleryBlock/config.js?macro=true";
import { default as configSo69tjycTVPF43gkMmX4HidSBW_ci_qSN305ArzHjm0Meta } from "/home/runner/work/web-frontend/web-frontend/pages/block-tests/blocks/ds_ButtonGroupBlock/config.js?macro=true";
import { default as block_45testsUvqTjjLqJjxsPg_4551uEssBpjBqPzRodo7UKrGR1zSD0Meta } from "/home/runner/work/web-frontend/web-frontend/pages/block-tests.vue?macro=true";
import { default as _91_46_46_46uri_93n0d_45jWHsiH_vboGMe02LTQCyR_45NhixIH4F9K8ReFFYUMeta } from "/home/runner/work/web-frontend/web-frontend/pages/news-feed/[...uri].vue?macro=true";
import { default as component_45stub6V0FgE6lV5Ma5eFV1X9miAmrR54L7URcn_9dcomtrCEMeta } from "/home/runner/work/web-frontend/web-frontend/node_modules/.pnpm/nuxt@3.17.7_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3_ny2rlnrwplqumtmdgnjctnhxn4/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub6V0FgE6lV5Ma5eFV1X9miAmrR54L7URcn_9dcomtrCE } from "/home/runner/work/web-frontend/web-frontend/node_modules/.pnpm/nuxt@3.17.7_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3_ny2rlnrwplqumtmdgnjctnhxn4/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/search.vue")
  },
  {
    name: "article",
    path: "/article",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/article.vue")
  },
  {
    name: "uri",
    path: "/:uri(.*)*",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/[...uri].vue")
  },
  {
    name: sectionspIfzhKb0mBRvKvAIZ7AEgghtQR3SM5N7oF7vRmDfRrsMeta?.name,
    path: "/sections",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections.vue"),
    children: [
  {
    name: "sections-form",
    path: "form",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/form.vue")
  },
  {
    name: "sections-tabs",
    path: "tabs",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/tabs.vue")
  },
  {
    name: "sections",
    path: "",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/index.vue")
  },
  {
    name: "sections-links",
    path: "links",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/links.vue")
  },
  {
    name: "sections-quote",
    path: "quote",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/quote.vue")
  },
  {
    name: "sections-table",
    path: "table",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/table.vue")
  },
  {
    name: "sections-tiles",
    path: "tiles",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/tiles.vue")
  },
  {
    name: "sections-video",
    path: "video",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/video.vue")
  },
  {
    name: "sections-images",
    path: "images",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/images.vue")
  },
  {
    name: "sections-layout",
    path: "layout",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/layout.vue")
  },
  {
    name: "sections-divider",
    path: "divider",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/divider.vue")
  },
  {
    name: "sections-gallery",
    path: "gallery",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/gallery.vue")
  },
  {
    name: "sections-accordion",
    path: "accordion",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/accordion.vue")
  },
  {
    name: "sections-rich-text",
    path: "rich-text",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/rich-text.vue")
  },
  {
    name: "sections-button-group",
    path: "button-group",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/button-group.vue")
  },
  {
    name: "sections-news-listing",
    path: "news-listing",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/news-listing.vue")
  },
  {
    name: "sections-feature-tiles",
    path: "feature-tiles",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/feature-tiles.vue")
  },
  {
    name: "sections-events-listing",
    path: "events-listing",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/events-listing.vue")
  },
  {
    name: "sections-events-calendar",
    path: "events-calendar",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/events-calendar.vue")
  },
  {
    name: "sections-staff-directory",
    path: "staff-directory",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/staff-directory.vue")
  },
  {
    name: "sections-social-media-feed",
    path: "social-media-feed",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/social-media-feed.vue")
  },
  {
    name: "sections-athletics-calendar",
    path: "athletics-calendar",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/athletics-calendar.vue")
  },
  {
    name: "sections-image-and-links-columns",
    path: "image-and-links-columns",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/image-and-links-columns.vue")
  },
  {
    name: "sections-image-and-text-accordion",
    path: "image-and-text-accordion",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/sections/image-and-text-accordion.vue")
  }
]
  },
  {
    name: block_45testsUvqTjjLqJjxsPg_4551uEssBpjBqPzRodo7UKrGR1zSD0Meta?.name,
    path: "/block-tests",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/block-tests.vue"),
    children: [
  {
    name: "block-tests",
    path: "",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/block-tests/index.vue")
  },
  {
    name: "block-tests-block",
    path: ":block()",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/block-tests/[block].vue")
  },
  {
    name: "block-tests-blocks-ds_TabsBlock-config",
    path: "blocks/ds_TabsBlock/config",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/block-tests/blocks/ds_TabsBlock/config.js")
  },
  {
    name: "block-tests-blocks-ds_ImagesBlock-config",
    path: "blocks/ds_ImagesBlock/config",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/block-tests/blocks/ds_ImagesBlock/config.js")
  },
  {
    name: "block-tests-blocks-ds_GalleryBlock-config",
    path: "blocks/ds_GalleryBlock/config",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/block-tests/blocks/ds_GalleryBlock/config.js")
  },
  {
    name: "block-tests-blocks-ds_ButtonGroupBlock-config",
    path: "blocks/ds_ButtonGroupBlock/config",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/block-tests/blocks/ds_ButtonGroupBlock/config.js")
  }
]
  },
  {
    name: "news-feed-uri",
    path: "/news-feed/:uri(.*)*",
    component: () => import("/home/runner/work/web-frontend/web-frontend/pages/news-feed/[...uri].vue")
  },
  {
    name: component_45stub6V0FgE6lV5Ma5eFV1X9miAmrR54L7URcn_9dcomtrCEMeta?.name,
    path: "/sitemaps-1-sitemap.xml",
    component: component_45stub6V0FgE6lV5Ma5eFV1X9miAmrR54L7URcn_9dcomtrCE
  },
  {
    name: component_45stub6V0FgE6lV5Ma5eFV1X9miAmrR54L7URcn_9dcomtrCEMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub6V0FgE6lV5Ma5eFV1X9miAmrR54L7URcn_9dcomtrCE
  }
]